import React from 'react';
import { Loader, Typography } from '@saviynt/design-system';

import './LoaderResponse.css';

export default function LoaderResponse() {
  return (
    <div className='Ispm-LoaderResponse'>
      <Loader kind='dots' format='inline' color='info' />
      {/* TODO: Localization here needed */}
      <Typography kind='body2' className='Ispm-LoaderResponse-text'>
        Responding. This may take a moment
      </Typography>
    </div>
  );
}
